import React, {useEffect, useState} from "react";
import {SpinnerOnTop} from "../../../components/SpinnerOnTop";
import t, {changeLanguage} from "../../../components/I18N/TranslateHelpers";
import {GetCurrentLocale} from "../../../components/Utils";
import {THEME_IMG, URL_FOR_RESOURCES} from "../../../app/AppConfig";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../../app/RootReducer";
import {FavouriteProducts} from "../../Entity/Product";
import {buttonForWishlist} from "../../../components/UtilsForCart";
import ProductPrice from "../../Products/ProductPrice/ProductPrice";
import {LocalParams} from "../../../components/LocalParams";
import {getUserAccount, getUserCatalog} from "../UsersSlice";

const WishlistProducts = () => {
  const token = LocalParams.getItem("token");
  useEffect(() => {
    if(token !== null){
      dispatch(getUserCatalog(token))
    }
  }, []);
  const locale = GetCurrentLocale();
  changeLanguage(locale)
  const isRequestingAdd = useSelector((state:RootState) => state.userRdc.isRequestingAdd)
  const isAuthenticated = useSelector((state: RootState) => state.userRdc.isAuthenticated);
  const isRequesting = useSelector((state:RootState) => state.userRdc.isRequesting)
  const dispatch = useDispatch()

  const [isInWishlist, setIsInWishlist] = useState(true)
  const [productIdRequest, setProductIdRequest] = useState(0)
  const [prevProductIdRequest, setPrevProductIdRequest] = useState(0)
  const favouriteProducts = useSelector((state: RootState) => state.userRdc.userDetail?.customer?.favouriteProducts);

  useEffect(() => {
    const fetchData = async () => {
      if (productIdRequest !== prevProductIdRequest) {
        setPrevProductIdRequest(productIdRequest);
        dispatch(getUserAccount());
      }
    };

    fetchData().then(r => setProductIdRequest(productIdRequest));
  }, [prevProductIdRequest]);

  return (
    <>
      {
        isRequesting ?
          <SpinnerOnTop/>
          :
          Array.isArray(favouriteProducts) ? (
              favouriteProducts && favouriteProducts.map((wishItem: FavouriteProducts) => (
            <article className="row gy-3 mb-4 align-items-center mt-0" key={wishItem.id}>
              <div className="col-lg-6 col-sm-7 mt-0">
                <div className="itemside me-lg-5">
                  <div className="aside">
                    {
                      wishItem.imageUrl !== null ?
                      <img src={URL_FOR_RESOURCES + "/media/image/" + wishItem.imageUrl } className="img-sm border rounded" alt={wishItem.name}/>
                      :
                      <img src={THEME_IMG + "/images/esm-no-product-image.png"} className="img-sm border rounded" alt={wishItem.name}/>
                    }

                  </div>
                  <div className="info">
                    <a href={"/" + locale + t('url_detail_product') + "/" + wishItem.slug} className="title mb-1">
                      {wishItem.name}
                    </a>
                    <div className="price-wrap">
                      <strong className="price">{wishItem.brand.name}</strong>
                      {/*<span className="price-old">{wishItem.code}</span>*/}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-2 col-sm-1 col-6 mt-0">
                <ProductPrice
                  productItem={{
                    ...wishItem,
                    id: wishItem.id,
                    price: wishItem.cheaperPrice,
                  }}
                  mode="wishlist"
                />
              </div>
              <div className="col-lg-2 col-sm-3 col-6 mt-0">
                <div className="price-wrap lh-sm">
                  <a href={"/" + locale + t('url_detail_product') + "/" + wishItem.slug } className="btn btn-primary w-100">
                    { t('view_article')}
                  </a>
                </div>
              </div>
              <div className="col-lg col-sm-1 mt-0">
                <div className="float-lg-end">
                  {
                    isRequestingAdd && wishItem.id === productIdRequest ?
                      <SpinnerOnTop/>
                      :
                      isAuthenticated ?
                        buttonForWishlist(false, dispatch, wishItem.id, setIsInWishlist, setProductIdRequest)
                        : null
                  }
                </div>
              </div>
            </article>
            ))
          ) :
            null
      }
    </>
  )
}
export default WishlistProducts;


